import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../filter/FilterButton'

const FilterButtonDevelopmentalRubric = ({ type = 'dr' }) => {
  const open = useSelector((state) => state?.filter?.[type]?.open || false)

  return (
    <>
      <FilterButton module={type} keysFilter={['yearLevel', 'subjectId']} />
      {open && <FilterDialog module={type} />}
    </>
  )
}
export default FilterButtonDevelopmentalRubric
